<template>
  <div class="account-locked" role="alert">
    <div class="locked-icon">
      <i class="material-icons">lock</i>
    </div>

    <h4 class="locked-title">Account locked</h4>

    <p class="locked-text">
      <template v-if="email">
        The account <strong>{{ email }}</strong> has been locked
      </template>
      <template v-else>Your account has been locked</template>
      after too many failed sign-in attempts.
    </p>
    <p class="locked-text">
      Please contact your administrator to unlock it, then sign in again.
    </p>

    <button
      type="button"
      class="btn btn-block btn-ghipss waves-effect"
      @click="$emit('back')"
    >
      BACK TO LOGIN
    </button>
  </div>
</template>

<script>
// Shown instead of the OTP step when the login response says isLocked
export default {
  name: "AccountLocked",
  props: {
    email: { type: String, default: "" },
  },
  emits: ["back"],
};
</script>

<style scoped>
.account-locked {
  text-align: center;
}
.locked-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 4px 0 12px;
  border-radius: 50%;
  background: rgba(7, 80, 132, 0.1);
  color: #075084;
}
.locked-icon .material-icons {
  font-size: 32px;
}
.locked-title {
  margin: 0 0 12px;
  color: #075084;
  font-weight: 700;
}
.locked-text {
  color: #555;
  font-size: 14px;
  margin-bottom: 8px;
}
.btn-ghipss {
  margin-top: 12px;
}
</style>
